import React from "react";

export const pages = [
    {
        url: '/',
        description: 'Home',
        notAuth: true,
        icon: (isSelected) => (
            <i className={`ri-home-4-${isSelected ? 'fill' : 'line'}`}
               style={{color: isSelected ? '#0061c6' : 'rgba(57, 164, 223, 1)', fontSize: '24px'}}></i>),
    },
    {
        url: '/dashboard',
        description: 'Início',
        isPublicAccess: true,
        allowAccessGestorSSE: true,
        icon: (isSelected) => (
            <i className={`ri-home-4-${isSelected ? 'fill' : 'line'}`}
               style={{color: isSelected ? '#0061c6' : 'rgba(57, 164, 223, 1)', fontSize: '24px'}}></i>),
    },
    {
        url: '/reports',
        description: 'Relatórios',
        isPublicAccess: true,
        allowAccessGestorSSE: true,
        icon: (isSelected) => (
            <i className={`ri-bar-chart-2-${isSelected ? 'fill' : 'line'}`}
               style={{color: isSelected ? '#0061c6' : 'rgba(57, 164, 223, 1)', fontSize: '24px'}}></i>),
    } ,
    {
        url: '/funcionalidades',
        description: 'Funcionalidades',
        icon: (isSelected) => (
            <i className={`ri-stack-${isSelected ? 'fill' : 'line'}`}
               style={{color: isSelected ? '#0061c6' : 'rgba(57, 164, 223, 1)', fontSize: '24px'}}></i>),
    },
    {
        url: '/notificacoes',
        description: 'Notificações',
        icon: (isSelected) => (
            <i className={`ri-notification-2-${isSelected ? 'fill' : 'line'}`}
               style={{color: isSelected ? '#0061c6' : 'rgba(57, 164, 223, 1)', fontSize: '24px'}}></i>),
    },
    {
        url: '/tabelas-de-controle',
        description: 'Tabelas de Controle',
        isPublicAccess: true,
        allowAccessGestorSSE: true,
        icon: (isSelected) => (
            <i className={`ri-file-copy-${isSelected ? 'fill' : 'line'}`}
               style={{color: isSelected ? '#0061c6' : 'rgba(57, 164, 223, 1)', fontSize: '24px'}}></i>),
    }
]